/**
 * This plugin create an axios HTTP client to do request.
 * It handles tokens too to acess to private routes on API.
 */
import Cookies from 'js-cookie';
import Cookie from 'cookie';
import {
  deleteForUser,
  forgetLastUserUuid,
  getLastUserUuid,
} from '@/services/listingDraftRepository';

export default {
  async beforeCreate(context) {
    let token;
    const { req, store, res, $http } = context;
    const cookieStr = process.browser ? document.cookie : req.headers.cookie;
    const cookies = require('cookie').parse(cookieStr || '') || {};
    token = cookies.BeliRumaAgentApp;
    const validToken = token && token !== 'null' && token !== 'undefined';
    const locale = cookies.locale;
    store.commit('global/SET_TOKEN', validToken ? token : null);
    store.commit('global/SET_LOCALE', locale);
    if (validToken) {
      $http.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
      delete $http.defaults.headers.common.Authorization;
    }
    $http.defaults.headers.common['Content-Language'] = locale ? locale : 'id';
    if (process.browser) {
      // ...Browser
      if (validToken) {
        Cookies.set('BeliRumaAgentApp', token, {
          expires: store.state.global.remember ? 365 : null,
        });
      } else {
        Cookies.remove('BeliRumaAgentApp');
      }
      Cookies.set('locale', locale, { expires: 10 });
    } else {
      // ...Server
      let params = {
        path: '/',
      };
      if (!validToken) {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        params.expires = yesterday;
      }
      res.setHeader(
        'Set-Cookie',
        Cookie.serialize('BeliRumaAgentApp', validToken ? token : '', params),
      );
      res.setHeader(
        'Set-Cookie',
        Cookie.serialize('locale', locale, { path: '/', expires: new Date() }),
      );
    }

    if (validToken) {
      try {
        const data = await $http.get('/api/user-agent');
        if (data.data.data) {
          await store.commit('global/SET_USER', data.data.data);
          await store.dispatch('global/getEnquiriesUnreadCount');
        }
      } catch (e) {
        if (process.browser) {
          const userUuid =
            (store.state.global.user && store.state.global.user.uuid) || getLastUserUuid();
          if (userUuid) {
            try {
              await deleteForUser(userUuid);
            } catch (draftError) {
              console.error('Failed to delete listing draft after auth expiry:', draftError);
            }
          }
          forgetLastUserUuid();
          Cookies.remove('BeliRumaAgentApp');
          Cookies.remove('user');
          store.commit('global/SET_USER', null);
        } else {
          let params = {
            path: '/',
          };
          const today = new Date();
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          params.expires = yesterday;
          res.setHeader('Set-Cookie', Cookie.serialize('BeliRumaAgentApp', token, params));
          res.setHeader('Set-Cookie', Cookie.serialize('user', null, params));
          store.commit('global/SET_USER', null);
        }
      }
    }
  },
};
